import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfConteudosRelacionadosSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo `href`
 * de cada item é um `object_browser` aninhado num `object_list` — e usa o
 * `dataAdapter` (ver `adapter.ts`) para preencher o rótulo com o título da
 * página assim que o editor escolhe um link interno (mesmo padrão de
 * `AcoesRapidas/Data.tsx`).
 */
const Data = (props: any) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfConteudosRelacionadosSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }: any) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: unknown) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
